import { render } from "./T-Foto.vue?vue&type=template&id=1124eafe"
import script from "./T-Foto.vue?vue&type=script&lang=js"
export * from "./T-Foto.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__